var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKucoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "#23af91"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426 512.1 151.6 151.7 95.7-95.7c17.1-15.4 43.3-14.7 59.6 1.6s17 42.5 1.6 59.6L608.2 755.5c-17 16.7-44.2 16.7-61.1 0L364.9 573.2v108.3c0 23.9-19.4 43.3-43.3 43.3s-43.3-19.4-43.3-43.3V342.4c0-23.9 19.4-43.3 43.3-43.3s43.3 19.4 43.3 43.3v108.3l182.2-182.2c17-16.7 44.2-16.7 61.1 0l126.4 126.3c15.4 17.1 14.7 43.3-1.6 59.6-16.3 16.3-42.5 17-59.6 1.6l-95.7-95.7L426 512.1zm151.8-43.4c-17.5 0-33.3 10.5-40.1 26.7-6.7 16.2-3 34.8 9.4 47.2s31 16.1 47.2 9.4c16.2-6.7 26.8-22.5 26.8-40 0-11.5-4.6-22.5-12.7-30.7-8.1-8-19.1-12.6-30.6-12.6z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKucoin);
export default __webpack_public_path__ + "static/media/Kucoin.f404b94a363834891e79d3dbad1b5239.svg";
export { ForwardRef as ReactComponent };